import React, {useEffect} from 'react';
import QuestionPanel from "../../structure/QuestionPanel";
import TextInput from "../../input/TextInput";
import OccupationRequirements from "../../structure/OccupationRequirements";
import { useFormikContext } from "formik";
import FrequencyTip from "../../structure/FrequencyTip";
import { useAuth } from "oidc-react";
import { EmployerFormValues } from "../../common/EmployerFormValues";
import {useQuery} from "@apollo/client";
import {
    FIND_WORK_LOCATION_QUERY,
    VALIDATE_PAID_FAMILY_AND_MEDICAL_LEAVE_WORK_LOCATION
} from "../../../Queries";
import LoadingSpinner from "../../structure/LoadingSpinner";

const Occupation = () => {
    const auth = useAuth();
    const userData = auth.userData;
    const signedIn = !!userData;
    const { initialValues, values, setFieldValue } = useFormikContext<EmployerFormValues>()
    const hasOccupationRequirements = initialValues && Object.keys(initialValues).includes("requiredSittingFrequency");
    const policyNumber = values.policyNumber;
    const privacyId = values.privacyId;
    const workState = values.workState;
    const isPfml = values.pfml;

    const { data: validatePaidFamilyAndMedicalLeaveWorkLocation } = useQuery(VALIDATE_PAID_FAMILY_AND_MEDICAL_LEAVE_WORK_LOCATION, {
        variables: {
            workState
        },
        skip: !workState
    })
    const needsWorkLocation = validatePaidFamilyAndMedicalLeaveWorkLocation?.validatePaidFamilyAndMedicalLeaveWorkLocation

    const { data: findWorkLocation, loading: findWorkLocationLoading } = useQuery(FIND_WORK_LOCATION_QUERY, {
        skip: !signedIn || !isPfml || !needsWorkLocation || policyNumber?.length !== 7 || privacyId?.length !== 9,
        variables: {
            policyId: policyNumber,
            memberId: privacyId
        }
    })
    const workLocation = findWorkLocation?.findWorkLocation;

    useEffect(() => {
        if (workLocation) {
            setFieldValue('workLocation', workLocation.workLocation)
        }
    }, [workLocation, setFieldValue])

    return (findWorkLocationLoading
            ? <LoadingSpinner spinnerText="Loading"/>
            : <QuestionPanel headerText="Please describe your employee's occupation."
                       detailsText={hasOccupationRequirements ? <FrequencyTip/> : undefined}
                       panelContent={
                           <div>
                               <TextInput id="job-title" label="Employee's job title" required={true} maxLength={320}/>
                               {needsWorkLocation &&
                                   <TextInput id="work-location" label="Work location" required={true} maxLength={1024}/>}
                               <OccupationRequirements label={hasOccupationRequirements
                                   ? "In a typical work day, your employee is required to:"
                                   : undefined} idPrefix="required" required={true}/>
                           </div>}
        >
        </QuestionPanel>
    )
};

export default Occupation;
